import { BCMSRecord, BCMSRecordProperty } from "bcms-react";
import { Account } from "model";

/**
 * @class Deposit
 * @classdesc Class definition for record tyupe from model
 * @param {OBJECT} record - Record from model to init class
 * @extends BCMSRecord
 * @example const record = new Depsoit(model.deposits[0]);
 * 
 * @property {NUMBER} _id - The id of the deposit
 * @property {BCMSDate} _date - The date of the deposit
 * @property {Account} _account - The account related to the deposit
 * @property {STRING} _status - The status of the deposit
 * @property {BCMSCurrency} _amount - The amount of the deposit
 * @property {STRING} _transactionID - The transaction id of the deposit
 * @property {STRING} _source - The source of the deposit
 * @property {BOOLEAN} _isCheck - The isCheck of the deposit
 */
export default class Deposit extends BCMSRecord {
    _id;
    _date;
    _account;
    _status;
    _amount;
    _transactionID;
    _source;
    _isCheck;

    constructor(record) {
        super(record);
    }

    static getSortedDeposits() {
        return Deposit.initAll().sort((a, b) => {
            if(b.record.date === a.record.date) { return b.id - a.id; }
            return b.date.date - a.date.date;
        });
    }
}

Deposit.define({
    "recordType" : "deposits",
    "recordIDProp": "id",
    "className" : "Deposit",
    "recordProperties": [
        /**
         * @name id
         * @instance
         * @property get {NUMBER} - gets the id of the deposit
         * @property set {NUMBER} - sets the id of the deposit
         * @memberof Deposit
         */
        BCMSRecordProperty.mapToNumber("id", "_id"),

        /**
         * @name date
         * @instance
         * @property get {BCMSDate} - gets the date of the deposit
         * @property set {BCMSDate} - sets the date of the deposit
         * @memberof Deposit
         */
        BCMSRecordProperty.mapToDate("date", "_date"),

        /**
         * @name account
         * @instance
         * @property get {Account} - gets the account of the deposit
         * @property set {Account} - sets the account of the deposit
         * @memberof Deposit
         */
        BCMSRecordProperty.mapToClass("account", "_account", () => Account),

        /**
         * @name status
         * @instance
         * @property get {STRING} - gets the status of the deposit
         * @property get {STRING} - sets the status of the deposit
         * @memberof Deposit
         */
        BCMSRecordProperty.mapToString("status", "_status"),

        /**
         * @name amount
         * @instance
         * @property get {BCMSCurrency} - gets the amount of the deposit
         * @property set {BCMSCurrency} - sets the amount of the deposit
         * @memberof Deposit
         */
        BCMSRecordProperty.mapToCurrency("amount", "_amount"),

        /**
         * @name transactionID
         * @instance
         * @property get {STRING} - gets the transaction id of the deposit
         * @property set {STRING} - sets the transaction id of the deposit
         * @memberof Deposit
         */
        BCMSRecordProperty.mapToString("transactionID", "_transactionID"),

        /**
         * @name source
         * @instance
         * @property get {STRING} - gets the source of the deposit
         * @property set {STRING} - sets the source of the deposit
         * @memberof Deposit
         */
        BCMSRecordProperty.mapToString("source", "_source"),

        /**
         * @name isCheck
         * @instance
         * @property get {BOOLEAN} - gets the isCheck of the deposit
         * @property set {BOOLEAN} - sets the isCheck of the deposit
         * @memberof Deposit
         */
        BCMSRecordProperty.mapToBoolean("isCheck", "_isCheck")
    ]
})